import { array, number, object, string } from 'yup';
import { VALIDATION } from './constants';
import { normalizeStackId } from './utils';

export const eventSchema = object().shape({
  title: string().required(VALIDATION.TITLE_REQUIRED.message),
  start: string().required(VALIDATION.START_DATE_REQUIRED.message),
  end: string()
    .default('')
    .test({
      name: VALIDATION.END_DATE_AFTER_START.code,
      message: VALIDATION.END_DATE_AFTER_START.message,
      test: function (value: string | undefined) {
        const { start } = this.parent as { start: string };
        if (!value || !start) {
          return true;
        }
        return new Date(value) > new Date(start);
      },
    }),
  rrule: object()
    .nullable()
    .default(null)
    .shape({
      freq: string().nullable(),
      interval: number().nullable(),
      byweekday: array().of(string()).nullable(),
      dtstart: string().nullable(),
      until: string()
        .transform((value) => (value === '' ? null : value))
        .nullable(),
    }),
  duration: string().required(VALIDATION.DURATION_REQUIRED.message),
  backgroundColor: string().required(
    VALIDATION.BACKGROUND_COLOR_REQUIRED.message,
  ),
  stackId: string()
    .transform((value) => (value === '' ? null : value))
    .nullable()
    .optional()
    .when(['startCommands', 'stopCommands'], {
      is: (
        startCommands: string[] | null | undefined,
        stopCommands: string[] | null | undefined,
      ) =>
        (!startCommands || startCommands.length === 0) &&
        (!stopCommands || stopCommands.length === 0),
      then: (schema) =>
        schema.test({
          name: VALIDATION.COMMANDS_OR_STACK_REQUIRED.code,
          message: VALIDATION.COMMANDS_OR_STACK_REQUIRED.message,
          test: (value) => normalizeStackId(value) !== null,
        }),
    }),
  startCommands: array().of(string()).nullable().optional(),
  stopCommands: array().of(string()).nullable().optional(),
});
